import React from "react";
import "./Coach.css";
import { Tooltip } from "antd";
import moment from "moment";
import { step_names } from './StepNames';

export default class StepViewCard extends React.Component {
  
  state = {
    color: "#585858",
    dateColor: "#888888",
    borderColor: "#585858",
    bg: "#F6FAFB",
    tooltipClass: "",
    showTooltip: false,
  };

  componentDidMount() {
    this.Component_style(this.props.status_cat);
  }

  Component_style = (value) => {
    if (value === "request-access") {
      this.setState({
        titleColor: "blue",
        dateColor: "#888888",
        borderColor: "blue",
        bg: "#F6FAFB",
        tooltipClass: value+"-tooltip",
        showTooltip: true,
      });
    }
    if (value === "for-review") {
      this.setState({
        titleColor: "#C8B700",
        dateColor: "#888888",
        borderColor: "#C8B700",
        bg: "#F6FAFB",
        tooltipClass: value+"-tooltip",
        showTooltip: false,
      });
    }
    if (value === "last-step-completed") {
      this.setState({
        titleColor: "#5CDA7E",
        dateColor: "#888888",
        borderColor: "#5CDA7E",
        bg: "#F6FAFB",
        tooltipClass: value+"-tooltip",
        showTooltip: false,
      });
    }
    if (value === "steps-in-progress") {
      this.setState({
        titleColor: "#E39203",
        dateColor: "#888888",
        borderColor: "#E39203",
        bg: "#F6FAFB",
        tooltipClass: value+"-tooltip",
        showTooltip: false,
      });
    }
  }
  
  render() {

    const tooltipContent = (text) => (
      <>
        <p style={{ fontSize: "15px", lineHeight: "18px", marginBottom: "0px", }}>{text}</p>
      </>
    )

    return (
      <>
        {/* {this.props.step_obj.map((step, i) => (
          console.log("satyam3", step, i)
        ))} */}
        <div
          className={[
            "div-content",
            `${this.props.status_cat}`+"-div",
          ].join(" ")}
        >
          {this.props.step_obj.map((step, i) => (

            step_names[step.step] && (   
              <div 
                key={i}
                className={[
                  "content-main-div",
                  this.props.status_cat,
                ].join(" ")}
                style={{
                  border: `1px solid ${this.state.borderColor}`,
                  backgroundColor: this.state.bg,
                }}
              >
                {/* <div> */}
                  <Tooltip
                    overlay={tooltipContent(step.notes)}
                    trigger="hover"
                    placement="right"
                    overlayClassName={[
                      "content-tooltip",
                      this.state.tooltipClass,
                      (this.state.showTooltip ? step.notes ? "" : "ant-tooltip-hidden" : "ant-tooltip-hidden")
                    ].join(" ")}
                  >
                    <span 
                      className={[
                        "title",
                        `${this.props.status_cat}`+"-title",
                      ].join(" ")}
                      style={{
                        color: this.state.titleColor,
                      }}
                    >
                      {/* {step.step_name ? step.step_name : step_names[step.step]} */}
                      {step_names[step.step]}
                    </span>
                  </Tooltip>
                {/* </div> */}
                {/* <div> */}
                  <Tooltip
                    overlay={tooltipContent(step.notes)}
                    trigger="hover"
                    placement="right"
                    overlayClassName={[
                      "content-tooltip",
                      this.state.tooltipClass,
                      (this.state.showTooltip ? step.notes ? "" : "ant-tooltip-hidden" : "ant-tooltip-hidden")
                    ].join(" ")}
                  >
                    <span 
                      className={[
                        "date",
                        `${this.props.status_cat}`+"-date",
                      ].join(" ")}
                      style={{
                        color: this.state.dateColor,
                      }}
                    >
                      {moment(step.date).format("MMM D, YYYY")}
                    </span>
                  </Tooltip>
                {/* </div> */}
              </div>
            )
            
          ))}
        </div>
      </>
    );
  }

}


// For Plus icons and modal box -- last step completed -- Ready for Review  --- Client Request 

// import React from "react";
// import "./Coach.css";
// import { Tooltip, Modal, Button } from "antd";
// import moment from "moment";

// export default class StepViewCard extends React.Component {
  
//   state = {
//     color: "#585858",
//     dateColor: "#888888",
//     borderColor: "#585858",
//     bg: "#F6FAFB",
//     tooltipClass: "",
//     showTooltip: false,
//     modalVisible: false, // State to manage modal visibility
//   };

//   componentDidMount() {
//     this.Component_style(this.props.status_cat);
//   }

//   Component_style = (value) => {
//     if (value === "request-access") {
//       this.setState({
//         titleColor: "blue",
//         dateColor: "#888888",
//         borderColor: "blue",
//         bg: "#F6FAFB",
//         tooltipClass: value + "-tooltip",
//         showTooltip: true,
//       });
//     }
//     if (value === "for-review") {
//       this.setState({
//         titleColor: "#C8B700",
//         dateColor: "#888888",
//         borderColor: "#C8B700",
//         bg: "#F6FAFB",
//         tooltipClass: value + "-tooltip",
//         showTooltip: false,
//       });
//     }
//     if (value === "last-step-completed") {
//       this.setState({
//         titleColor: "#5CDA7E",
//         dateColor: "#888888",
//         borderColor: "#5CDA7E",
//         bg: "#F6FAFB",
//         tooltipClass: value + "-tooltip",
//         showTooltip: false,
//       });
//     }
//     if (value === "steps-in-progress") {
//       this.setState({
//         titleColor: "#E39203",
//         dateColor: "#888888",
//         borderColor: "#E39203",
//         bg: "#F6FAFB",
//         tooltipClass: value + "-tooltip",
//         showTooltip: false,
//       });
//     }
//   };

//   // Function to toggle modal visibility
//   toggleModal = () => {
//     this.setState({ modalVisible: !this.state.modalVisible });
//   };

//   render() {
//     const { step_obj } = this.props;
//     if (!step_obj || step_obj.length === 0) return null; // If no data, return nothing

//     const tooltipContent = (text) => (
//       <p style={{ fontSize: "15px", lineHeight: "18px", marginBottom: "0px" }}>
//         {text}
//       </p>
//     );

//     return (
//       <>
//         <div className={["div-content", `${this.props.status_cat}-div`].join(" ")}>
//           {/* Render the first step */}
//           <div
//             className={["content-main-div", this.props.status_cat].join(" ")}
//             style={{
//               border: `1px solid ${this.state.borderColor}`,
//               backgroundColor: this.state.bg,
//               position: "relative",
//             }}
//           >
//             <Tooltip
//               overlay={tooltipContent(step_obj[0].notes)}
//               trigger="hover"
//               placement="right"
//               overlayClassName={[
//                 "content-tooltip",
//                 this.state.tooltipClass,
//                 this.state.showTooltip ? "" : "ant-tooltip-hidden",
//               ].join(" ")}
//             >
//               <span
//                 className={["title", `${this.props.status_cat}-title`].join(" ")}
//                 style={{ color: this.state.titleColor }}
//               >
//                 {step_obj[0].step_name}
//               </span>
//             </Tooltip>

//             <Tooltip
//               overlay={tooltipContent(step_obj[0].notes)}
//               trigger="hover"
//               placement="right"
//               overlayClassName={[
//                 "content-tooltip",
//                 this.state.tooltipClass,
//                 this.state.showTooltip ? "" : "ant-tooltip-hidden",
//               ].join(" ")}
//             >
//               <span
//                 className={["date", `${this.props.status_cat}-date`].join(" ")}
//                 style={{ color: this.state.dateColor }}
//               >
//                 {moment(step_obj[0].date).format("MMM D, YYYY")}
//               </span>
//             </Tooltip>
//             {step_obj.length > 1 && (
//             <button
//               type="primary"
//               onClick={this.toggleModal}
//               style={{ marginLeft: "10px" , position:"absolute", top: "20px", right: "5px" , borderRadius:"50%"}}
//             >
//               +
//             </button>
//           )}
//           </div>

//           {/* Show + button if more than one step exists */}
          
//         </div>

//         {/* Modal for showing all steps */}
//         <Modal
//           title="All Steps"
//           visible={this.state.modalVisible}
//           onCancel={this.toggleModal}
//           footer={null}
//         >
//           {step_obj.map((step, i) => (
//             <div
//               key={i}
//               className={["content-main-div", this.props.status_cat].join(" ")}
//               style={{
//                 border: `1px solid ${this.state.borderColor}`,
//                 backgroundColor: this.state.bg,
//                 marginBottom: "10px",
//                 padding: "10px",
//               }}
//             >
//               <Tooltip
//                 overlay={tooltipContent(step.notes)}
//                 trigger="hover"
//                 placement="right"
//                 overlayClassName={[
//                   "content-tooltip",
//                   this.state.tooltipClass,
//                   this.state.showTooltip ? "" : "ant-tooltip-hidden",
//                 ].join(" ")}
//               >
//                 <span
//                   className={["title", `${this.props.status_cat}-title`].join(" ")}
//                   style={{ color: this.state.titleColor }}
//                 >
//                   {step.step_name}
//                 </span>
//               </Tooltip>

//               <Tooltip
//                 overlay={tooltipContent(step.notes)}
//                 trigger="hover"
//                 placement="right"
//                 overlayClassName={[
//                   "content-tooltip",
//                   this.state.tooltipClass,
//                   this.state.showTooltip ? "" : "ant-tooltip-hidden",
//                 ].join(" ")}
//               >
//                 <span
//                   className={["date", `${this.props.status_cat}-date`].join(" ")}
//                   style={{ color: this.state.dateColor }}
//                 >
//                   {moment(step.date).format("MMM D, YYYY")}
//                 </span>
//               </Tooltip>
//             </div>
//           ))}
//         </Modal>
//       </>
//     );
//   }
// }
